import styled from "styled-components";
import { Drawer } from "antd";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .ant-drawer-title strong {
    font-family: "Asap", sans-serif;
    font-size: 16px;
    color: #591f74;
  }
`;

export const Body = styled.div`
  width: 100%;
  padding: 0px 24px;
  min-height: -moz-calc(100vh - 165px);
  min-height: -webkit-calc(100vh - 165px);
  min-height: calc(100vh - 165px);

  .empty {
    color: #9074bf;
  }

  .ant-table-thead > tr > th {
    background: transparent;
    font-size: 11px;
    text-transform: uppercase;
    color: #8a50a5;
  }

  .flags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  .flag {
    font-family: "Asap", sans-serif;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 1px 7px;
    border-radius: 9px;
    background: #ede4f7;
    color: #6b2d8c;
    white-space: nowrap;
  }

  .observation {
    margin-top: 16px;
    font-family: "Asap", sans-serif;
    font-size: 13px;
    color: #4b4b4b;
  }
`;

export const HeaderFields = styled.div`
  width: 100%;
  margin-bottom: 16px;

  .ant-row-flex {
    margin-bottom: 6px;
  }

  span.label {
    font-family: "Asap", sans-serif;
    font-size: 13px;
    color: #8a50a5;
    font-weight: bold;
    margin-right: 6px;
  }

  span.value {
    font-family: "Asap", sans-serif;
    font-size: 14px;
    color: #4b4b4b;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid #e8e8e8;
  margin-top: 20px;
  width: 100%;
  padding: 10px 24px;
  border-radius: 0 0 4px 4px;

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;
